module.exports = __webpack_public_path__ + "img/event_page_2.4b65a8e8.png";